import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './FinalSaleDescription.module.scss';

export const FinalSaleDescription = ({
  description,
  className = {},
  addBorder = false,
}) => {
  const rootClasses = clsx(styles.root, className?.root, {
    [styles.border]: addBorder,
  });
  return (
    <div className={rootClasses}>
      <span
        className={`${className?.finalSale} ${styles.finalSale} ${styles.text}`}
      >
        FINAL SALE:{' '}
      </span>
      <span className={`${className?.description} ${styles.text} `}>
        {description}
      </span>
    </div>
  );
};

FinalSaleDescription.propTypes = {
  description: PropTypes.string,
};

FinalSaleDescription.defaultProps = {
  description: 'This product cannot be returned or exchanged unless faulty.',
};
